<template>
  <vue-tel-input
    :value="value"
    @input="onInput"
    :inputOptions="{ showDialCode: true }"
    :dropdownOptions="{ tabindex: -1, showFlags: true, showDialCodeInList: true }"
    :validCharactersOnly="true"
    :preferredCountries="['FR', 'ES', 'BE', 'DE']"
  />
</template>

<script>
export default {
  name: "PhoneInput",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  methods: {
    onInput(phone, phoneObject) {
      this.$emit("input", phone, phoneObject);
    },
  },
};
</script>

<style scoped>
.vue-tel-input :deep(.vti__input),
.vue-tel-input :deep(input.vti__input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
  border-radius: 0 !important;
  height: 100% !important;
  padding: 0 10px !important;
  font-size: 16px !important;
  width: 100% !important;
}

.vue-tel-input :deep(.vti__input:hover),
.vue-tel-input :deep(.vti__input:focus),
.vue-tel-input :deep(input.vti__input:hover),
.vue-tel-input :deep(input.vti__input:focus) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
}

.vue-tel-input :deep(.vti__dropdown) {
  background-color: transparent !important;
  border: none !important;
  padding: 0 8px !important;
}

.vue-tel-input :deep(.vti__dropdown:hover) {
  background-color: transparent !important;
}

.vue-tel-input {
  position: relative !important;
}

.vue-tel-input :deep(.vti__dropdown) {
  position: static !important;
}

.vue-tel-input :deep(.vti__dropdown-list) {
  width: 100% !important;
  left: 0 !important;
  right: 0 !important;
  position: absolute !important;
  top: 100% !important;
  border-radius: 8px !important;
  margin-top: 6px !important;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px !important;
}

.vue-tel-input :deep(.vti__flag-wrapper) {
  display: none !important;
}

.vue-tel-input :deep(.vti__dropdown-item) {
  display: flex;
  justify-content: space-between;
  color: rgb(55, 53, 47);
  font-size: 14px;
}

.vue-tel-input :deep(.vti__dropdown-item strong) {
  font-weight: inherit;
  color: inherit;
}
</style>
